import type {PortfolioType, ReviewType} from "~/types/Portfolio";
import type {LanguageType} from "~/types/Dictionary";
import type {SpecificationType} from "~/types/Specification";
import type {StrapiFileType} from "~/types/Files";

export interface UserCardType {
    avatar: {
        documentId: string
        id: number
        url: string
    } | null
    documentId: string
    id: number,
    username: string | null
    
    /* compute_rating: number | null
    compute_review_count: number | null */
}

export interface UserPageType extends UserCardType {
    is_active: boolean
    email: string | null
    phone: string | null
    gender: GenderEnum | null
    date_of_birth: string | null
    biography: string | null
    user_role: RoleEnum | null
    reviews: ReviewType[]
    specifications: SpecificationType[]
    portfolios: PortfolioType[]
    languages: LanguageType[]
}

export interface UserType extends UserPageType {
    user_roles: RoleEnum[]
    responses: string[]
    payment_customer_id: string | null
    payment_account_id: string | null
    ziina_account_id: string | null
    jobtoken_wallet: string | null
    jobtoken_balance: number | null
    accept_rules_date: string | null
    available_task_boosts_count: number | null
    unread_master_responses_count: number | null
    unread_customer_responses_count: number | null
}

export enum GenderEnum {
    M = 'MALE',
    F = 'FEMALE'
}

export enum RoleEnum {
    MASTER = 'MASTER',
    CUSTOMER = 'CUSTOMER',
}